import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "./Logo";
import { scrollToId } from "./scrollTo";

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const toTop = () => {
        if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <motion.header
            initial={{ y: -28, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
                scrolled
                    ? "border-b border-white/[0.06] bg-[#0a0a0b]/80 backdrop-blur-xl"
                    : "border-b border-transparent"
            }`}
        >
            <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 md:h-[72px] md:px-8">
                <button
                    type="button"
                    data-testid="nav-home"
                    onClick={toTop}
                    className="flex items-center gap-2.5"
                >
                    <LogoMark size={26} />
                    <span className="text-[11px] font-bold tracking-[0.35em] text-acid md:text-xs">
                        MONEYMUSCLE
                    </span>
                </button>
                <nav className="hidden items-center gap-9 text-sm text-[#9c9c96] md:flex">
                    <button
                        type="button"
                        data-testid="nav-features-link"
                        onClick={() => scrollToId("features")}
                        className="transition-colors duration-300 hover:text-white"
                    >
                        Features
                    </button>
                    <button
                        type="button"
                        data-testid="nav-faq-link"
                        onClick={() => scrollToId("faq")}
                        className="transition-colors duration-300 hover:text-white"
                    >
                        FAQ
                    </button>
                </nav>
                <button
                    type="button"
                    data-testid="nav-cta-button"
                    onClick={() => scrollToId("waitlist")}
                    className="touch-manipulation rounded-full bg-acid px-4 py-2.5 text-xs font-bold text-ink transition-all duration-300 hover:scale-105 hover:shadow-glow-sm active:scale-95 md:px-5 md:py-2 md:text-sm"
                >
                    Join the waitlist
                </button>
            </div>
        </motion.header>
    );
};
